import { defineComponent as p, useAttrs as v, useCssModule as _, computed as c, createElementBlock as i, openBlock as d, mergeProps as u, unref as a, toDisplayString as h } from "vue";
import b from "./utils/colorScheme.js";
import { _ as k } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const g = ["alt", "src", "tabindex"], x = ["tabindex"], C = /* @__PURE__ */ p({
  name: "ll-avatar",
  __name: "Avatar",
  props: {
    name: { default: "" },
    colorScheme: { default: "ice" },
    shade: { default: "light" },
    src: { default: void 0 },
    alt: { default: void 0 },
    bgColor: { default: void 0 },
    textColor: { default: void 0 }
  },
  setup(m) {
    const t = m, s = v(), e = _(), n = c(
      () => b({
        shade: t.shade,
        color: t.colorScheme
      })
    ), f = c(() => {
      const [l, r] = String(t.name).toUpperCase().split(" ");
      return r ? l.charAt(0) + r.charAt(0) : l.charAt(0);
    }), o = c(() => !!s.onClick);
    return (l, r) => t.src ? (d(), i("img", u({
      key: 0,
      class: ["stash-avatar stash-avatar--image tw-inline-block tw-rounded-full", [a(e).root, { [a(e).clickable]: o.value }]],
      alt: t.alt,
      src: t.src,
      tabindex: o.value ? 0 : -1,
      "data-test": "stash-avatar"
    }, a(s)), null, 16, g)) : (d(), i("div", u({
      key: 1,
      class: ["stash-avatar stash-avatar--initials tw-inline-block tw-cursor-default tw-rounded-full tw-text-center tw-font-semibold", [
        a(e).root,
        `tw-text-${t.textColor || n.value.computedTextColor}`,
        `tw-bg-${t.bgColor || n.value.computedBgColor}`,
        { [a(e).clickable]: o.value }
      ]],
      tabindex: o.value ? 0 : -1,
      "data-test": "stash-avatar"
    }, a(s)), h(f.value), 17, x));
  }
}), w = "_root_g79af_2", A = "_clickable_g79af_9", y = {
  root: w,
  clickable: A
}, S = {
  $style: y
}, D = /* @__PURE__ */ k(C, [["__cssModules", S]]);
export {
  D as default
};
//# sourceMappingURL=Avatar.js.map
